import React, { useEffect, useState, useCallback } from 'react'
import { TextField, Grid, Box, Button, FormHelperText } from "@mui/material"
import { useForm, Controller } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup"
import { DriveUsElevenSchema } from '../../Utils/Validations'
import FileValidations from '../FileValidation/FileValidations'
import DriveWithUsState from '../../Hooks/DriveWithUs.state'
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import 'lightbox2/dist/css/lightbox.min.css';
import lightbox from 'lightbox2';
import $ from 'jquery';



const getCarInspectionMaxDate = () => dayjs().add(4, "month").endOf("month");

// Date that will actually be saved: if user selects beyond 4 months, snap to 4th-month end
const getEffectiveCarInspectionExpiryDisplay = (val) => {
  if (val == null) return null;
  const selected = dayjs.isDayjs(val) ? val : dayjs(val);
  if (!selected.isValid()) return null;
  const max = getCarInspectionMaxDate();
  const effective = selected.isAfter(max, "day") ? max : selected;
  return effective.format("MM/DD/YYYY");
};

const DriveWithUsEleven = ({ handleBack, handleComplete, driveUsData, setDriveUsData, }) => {
  const [car_inspec_expiry, setCar_inspec_expiry] = React.useState(null);
  const [car_inspec_pic, setCar_inspec_pic] = useState()
  const [openImage, setOpenImage] = useState("")
  const [openModal, setOpenModal] = useState(false)
  const { SaveDriveWithUs, formBusy, response, progress } = DriveWithUsState()
  const { CheckFile, fileError } = FileValidations()

  const { handleSubmit, control, formState: { errors }, setValue } = useForm({
    resolver: yupResolver(DriveUsElevenSchema)
  })

  const onSubmit = (data) => {
    if (Object.keys(fileError).length === 0) {
      const formData = new FormData()
      formData.append("created_at", driveUsData.started_from || new Date().toISOString().split('T')[0])
      formData.append("first_name", driveUsData.first_name)
      formData.append("last_name", driveUsData.last_name)
      formData.append("company", driveUsData.company || "")
      formData.append("address", driveUsData.address)
      formData.append("apt", driveUsData.apt)
      formData.append("city", driveUsData.city)
      formData.append("state", driveUsData.state)
      formData.append("zip_code", driveUsData.zip_code)
      formData.append("phone", driveUsData.phone)
      formData.append("email", driveUsData.email)
      formData.append("password", driveUsData.password)
      formData.append("driver_license", driveUsData.driver_license)
      formData.append("driver_license_expiry", driveUsData.driver_license_expiry)
      formData.append("driver_license_number", driveUsData.driver_license_number)
      formData.append("tlc_license", driveUsData.tlc_license)
      formData.append("tlc_license_expiry", driveUsData.tlc_license_expiry)
      formData.append("tlc_license_number", driveUsData.tlc_license_number)
      formData.append("profile_pic", driveUsData.profile_pic)
      formData.append("vehicle_pic", driveUsData.vehicle_pic)
      formData.append("vehicle_reg", driveUsData.vehicle_reg_pic)
      formData.append("vehicle_reg_expiry", driveUsData.vehicle_reg_expiry)
      formData.append("vehicle_reg_plate", driveUsData.vehicle_reg_plate)
      formData.append("vehicle_reg_pin", driveUsData.vehicle_reg_pin)
      formData.append("car_inspection", car_inspec_pic)
      formData.append(
        "car_inspection_expiry",
        dayjs.isDayjs(car_inspec_expiry) ? car_inspec_expiry.format("YYYY-MM-DD") : (car_inspec_expiry || "")
      )
      formData.append("diamond_sticker", driveUsData.diamond_sticker_pic)
      formData.append("diamond_sticker_expiry", driveUsData.diamond_sticker_expiry)
      formData.append("diamond_sticker_number", driveUsData.diamond_sticker_number)
      formData.append("liability_insurance", driveUsData.liability_insurance_pic)
      formData.append("liability_insurance_expiry", driveUsData.liability_insurance_expiry)
      formData.append("social_security", driveUsData.social_security_pic)
      formData.append("social_security_number", data.social_security_number)
      formData.append("fh1_insurance", driveUsData.fh1_insurance_pic)
      formData.append("vehicle_pic_pin", driveUsData.vehicle_reg_pin)
      formData.append("diamond_sticker_pin", driveUsData.vehicle_reg_pin)
      formData.append("liability_insurance_pin", driveUsData.vehicle_reg_pin)
      formData.append("fh1_insurance_pin", driveUsData.vehicle_reg_pin)
      formData.append("car_inspection_pin", driveUsData.vehicle_reg_pin)


      SaveDriveWithUs(formData)
      handleComplete()


    }

  }


  useEffect(() => {
    lightbox.option({
      'resizeDuration': 200,
      'wrapAround': true,
    });
    const carExp = driveUsData.car_inspec_expiry
      ? dayjs(driveUsData.car_inspec_expiry)
      : null;
    const max = getCarInspectionMaxDate();
    const effective = carExp && carExp.isValid() && carExp.isAfter(max, "day") ? max : carExp;
    setCar_inspec_expiry(effective);
    setValue("car_inspec_expiry", effective)
  }, [driveUsData.car_inspec_expiry, setValue])

  const handleDateChange = useCallback((newValue, onChange) => {
    const max = getCarInspectionMaxDate();
    const v = newValue && dayjs.isDayjs(newValue) ? newValue : (newValue ? dayjs(newValue) : null);
    const effective = v && v.isValid() && v.isAfter(max, "day") ? max : v;
    setCar_inspec_expiry(effective);
    onChange(effective);
  }, []);


  const onChangeFiles = (file, name) => {
    if (!file) {
      console.warn('No file selected');
      return;
    }

    // Use setTimeout to handle file processing asynchronously without blocking the form
    setTimeout(() => {
      try {
        CheckFile(file, name);

        if (name === "social_security_pic") {
          setDriveUsData((prev) => ({ ...prev, social_security_pic: file }))
        } else if (name === "car_inspec_pic") {
          setCar_inspec_pic(file)
        }
      } catch (error) {
        console.error('Error handling file selection:', error);
      }
    }, 50); // Small delay for mobile devices
  }

  const handleOpenModal = (image) => {
    setOpenModal(true)
    setOpenImage(image)
    setTimeout(() => {
      $(document).ready(() => {
        $(`[href="${image}"]`).click();
      });
    }, 0);
  


}


  return (
    <div>
 {openModal && (
          <a
            href={`${openImage}`}
            data-lightbox="gallery"
            data-title="Image"
            style={{ display: 'none' }}
          >
            Open Image
          </a>
        )}
      <Grid container style={{ justifyContent: "center", marginTop: 20 }} >
        <Grid sm={6} xs={12} sx={{ textAlign: "left", paddingRight: { sm: 1, xs: 0 } }} >
          <Controller
            control={control}
            name="social_security_pic"
            rules={{ required: true }}
            render={({ field: { onBlur, onChange, value } }) => (
              <>

                <label>Social Security</label>
                <TextField 
                  fullWidth 
                  type="file" 
                  value={value} 
                  onBlur={onBlur} 
                  inputProps={{ 
                    onChange: (e) => { 
                      const file = e.target.files?.[0];
                      if (file) {
                        onChange(e); 
                        onChangeFiles(file, "social_security_pic");
                      }
                    },
                    accept: "image/*,.pdf,.doc,.docx"
                  }} 
                  error={errors?.social_security_pic || fileError?.social_security_pic} 
                  helperText={errors?.social_security_pic?.message || fileError?.social_security_pic?.message} 
                />
                <Box sx={{display:"flex",justifyContent:"space-between",alignItems:"center"}} >
                  <Box>
                <span className='image-detail' >Select any file or image</span><br />
                <span className='image-detail' >Maximum file size: 50MB</span>

                  </Box>
                  <img src='/driver_forms/assets/images/Social-Security-Card.jpg' style={{height:50}} onClick={()=>handleOpenModal("/driver_forms/assets/images/Social-Security-Card.jpg")}  />
                </Box>
              </>
            )}
          />


        </Grid>

        <Grid sm={6} xs={12} sx={{ textAlign: "left", paddingRight: { sm: 1, xs: 0 } }} >
          <Controller
            control={control}
            name="social_security_number"
            rules={{ required: true }}
            render={({ field: { onBlur, onChange, value } }) => (
              <>

                <label>Social Security Number </label>
                <TextField inputProps={{maxLength:11}} fullWidth type="text" value={value} onBlur={onBlur} onChange={(e) => {
          const input = e.target.value.replace(/\D/g, '');
          const formattedInput = input.replace(/(\d{3})(\d{2})?(\d{4})?/, (match, p1, p2, p3) => {
            let result = p1;
            if (p2) result += `-${p2}`;
            if (p3) result += `-${p3}`;
            return result;
          });
          
          onChange(formattedInput);
        }} error={errors.social_security_number} helperText={errors?.social_security_number?.message} on />

              </>
            )}
          />


        </Grid>
        <Grid sm={6} xs={12} sx={{ textAlign: "left", paddingRight: { sm: 1, xs: 0 }, mt: 3 }} >
          <Controller
            control={control}
            name="car_inspec_pic"
            rules={{ required: true }}
            render={({ field: { onBlur, onChange, value } }) => (
              <>
                <label>Car Inspection</label>
                <TextField 
                  fullWidth 
                  type="file" 
                  value={value} 
                  onBlur={onBlur} 
                  inputProps={{ 
                    onChange: (e) => { 
                      const file = e.target.files?.[0];
                      if (file) {
                        onChange(e); 
                        onChangeFiles(file, "car_inspec_pic");
                      }
                    },
                    accept: "image/*,.pdf,.doc,.docx"
                  }} 
                  error={errors?.car_inspec_pic || fileError?.car_inspec_pic} 
                  helperText={errors?.car_inspec_pic?.message || fileError?.car_inspec_pic?.message} 
                />
                <Box sx={{display:"flex",justifyContent:"space-between",alignItems:"center"}} >
                  <Box>
                <span className='image-detail' >Select any file or image</span><br />
                <span className='image-detail' >Maximum file size: 50MB</span>

                  </Box>
                  <img src='/driver_forms/assets/images/INSPECTION STICKER.jpg' style={{height:50}} onClick={()=>handleOpenModal("/driver_forms/assets/images/INSPECTION STICKER.jpg")}  />
                </Box>


              </>
            )}
          />


        </Grid>
        <Grid sm={6} xs={12} sx={{ textAlign: "left", paddingLeft: { sm: 1, xs: 0 }, mt: 3 }}>
          <Controller
            control={control}
            name="car_inspec_expiry"
            rules={{ required: true }}
            render={({ field: { onBlur, onChange, value } }) => (
              <>
                <label>Car Inspection Expiry{value ? `  — Expires: ${getEffectiveCarInspectionExpiryDisplay(value)}` : ""}</label>
                <DatePicker
                  sx={{ width: "100%" }}
                  className='date-picker'
                  value={value}
                  onChange={(newValue) => handleDateChange(newValue, onChange)}
                  minDate={dayjs()}
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      error: !!errors.car_inspec_expiry,
                      helperText: errors.car_inspec_expiry?.message
                    }
                  }}
                />

                {errors.car_inspec_expiry ? <FormHelperText component="p" sx={{ color: "#d32f2f", px: 1.5 }} >{errors.car_inspec_expiry?.message}</FormHelperText> : null}
              </>
            )}
          />


        </Grid>
      </Grid>
      <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
        <Button
          color="inherit"
          // disabled={activeStep === 0}
          onClick={handleBack}
          sx={{ minWidth: "10%", border: "none", color: "#FFF", bgcolor: "#97c11e", '&:hover': { bgcolor: "#021b38", border: "none" } }}
          variant="contained"
        >
          Back
        </Button>
        <Box sx={{ flex: '1 1 auto' }} />


        <Button color="inherit" variant="contained" sx={{ minWidth: "10%", border: "none", color: "#FFF", bgcolor: "#97c11e", '&:hover': { bgcolor: "#021b38", border: "none" } }} onClick={handleSubmit(onSubmit)}>


          {formBusy ? "Please wait..." : "Submit"}
        </Button>

      </Box>
    </div>
  )
}

export default DriveWithUsEleven